var React = require('react');

function BannerBorder (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1004.13,141.66H357.5v86.21s309.25-122.06,646.63,29.49","transform":"translate(-357.5 -141.66)","fill":"#002130"}));
}

BannerBorder.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 646.63 115.7"};

module.exports = BannerBorder;

BannerBorder.default = BannerBorder;
